import Api from 'api'

const config = {
  baseURL: '/api/app/v1/vk-ads',
}
const api = new Api(config)

api.fetchAccounts = ({ ...rest }) => api.get('/agency-clients', { ...rest })

api.fetchCampaigns = ({ ...rest }) => api.get('/campaigns', { ...rest })
api.fetchCampaignsStatistics = ({ ...rest }) =>
  api.get('/statistics/campaigns', { ...rest })
api.renameCampaign = ({ external_id, ...rest }) =>
  api.post(`/campaigns/${external_id}/rename`, { ...rest })
api.updateCampaigns = ({ ...rest }) =>
  api.post(`/campaigns/update`, { ...rest })

api.fetchAdGroups = ({ ...rest }) => api.get('/ad-groups', { ...rest })
api.fetchAdGroupsStatistics = ({ ...rest }) =>
  api.get('/statistics/ad-groups', { ...rest })
api.renameAdGroup = ({ external_id, ...rest }) =>
  api.post(`/ad-groups/${external_id}/rename`, { ...rest })
api.updateAdGroups = ({ ...rest }) => api.post(`/ad-groups/update`, { ...rest })

api.fetchAdGroupsCounter = ({ ...rest }) =>
  api.get(`/ad-groups/count`, { ...rest })

api.fetchBanners = ({ ...rest }) => api.get('/banners', { ...rest })
api.fetchBannersStatistics = ({ ...rest }) =>
  api.get('/statistics/banners', { ...rest })
api.renameBanner = ({ external_id, ...rest }) =>
  api.post(`/banners/${external_id}/rename`, { ...rest })
api.fetchBannersCounter = ({ ...rest }) =>
  api.get(`/banners/count`, { ...rest })

api.activate = ({ resource, ...rest }) =>
  api.post(`/${resource}/activate`, { ...rest })
api.block = ({ resource, ...rest }) =>
  api.post(`/${resource}/block`, { ...rest })
api.delete = ({ resource, ...rest }) =>
  api.post(`/${resource}/delete`, { ...rest })

export default api
